const createHtmlContainer = (html: string) => {
  const container = document.createElement("div");
  container.innerHTML = html;
  return container;
};

const getSafeSourcePrefix = (html: string, sourceLength: number): string => {
  let prefixEnd = Math.max(0, Math.min(sourceLength, html.length));

  // Do not split a UTF-16 surrogate pair.
  if (
    prefixEnd > 0 &&
    prefixEnd < html.length &&
    /[\uD800-\uDBFF]/.test(html[prefixEnd - 1]) &&
    /[\uDC00-\uDFFF]/.test(html[prefixEnd])
  ) {
    prefixEnd -= 1;
  }

  let tagStart = -1;
  let quote: '"' | "'" | null = null;

  for (let index = 0; index < prefixEnd; index += 1) {
    const character = html[index];

    if (tagStart === -1) {
      if (
        character === "<" &&
        (index + 1 === html.length || /[A-Za-z/!?]/.test(html[index + 1]))
      ) {
        tagStart = index;
      }
      continue;
    }

    if (quote) {
      if (character === quote) {
        quote = null;
      }
      continue;
    }

    if (character === '"' || character === "'") {
      quote = character;
    } else if (character === ">") {
      tagStart = -1;
    }
  }

  // An unfinished tag is counted as streamed progress, but is held out of the
  // editor until it is syntactically safe. The live caret remains visible in
  // the last rendered block while the source cursor moves through the tag.
  if (tagStart !== -1) {
    prefixEnd = tagStart;
  }

  return html.slice(0, prefixEnd);
};

/**
 * Returns an HTML source prefix while keeping the surrounding HTML balanced.
 *
 * Unlike text-length truncation, source-length truncation consumes markup in
 * the animation budget. A buffered paragraph therefore reveals continuously
 * instead of appearing almost all at once when its final tag arrives.
 */
export const truncateHtmlBySourceLength = (
  html: string,
  sourceLength: number
): string => {
  if (!html || sourceLength <= 0) {
    return "";
  }

  return createHtmlContainer(getSafeSourcePrefix(html, sourceLength)).innerHTML;
};
